import {
  Text,
  Html,
  ContactShadows,
  PresentationControls,
  Float,
  Lightformer,
  MeshPortalMaterial,
  OrbitControls,
  useGLTF,
  Stage,
  Environment,
  Sky,
} from "@react-three/drei";

import { useControls } from "leva";
import { Perf } from "r3f-perf";
import { Suspense } from "react";

import Gameboy from "./Gameboy.jsx";
import Screen from "./Screen.jsx";
import Seeus from "./Seeus.jsx";

export default function Experience() {
  return (
    <>
      {/* Environment */}

      <OrbitControls
        makeDefault
        target={[0, 0, 0]}
        minAzimuthAngle={-Math.PI / 1.5}
        maxAzimuthAngle={Math.PI / 1.5} //1.5
        minPolarAngle={Math.PI / 3} //3
        maxPolarAngle={Math.PI - Math.PI / 2} //2
        enableDamping={true}
        enablePan={false}
        minDistance={5.5}
        maxDistance={9}
      />

      {/* Environment */}

      <ambientLight intensity={0.2} position={[2, 2, 2]} />

      {/* Plane  */}

      <Suspense>
        <Stage
          preset="portrait"
          intensity={0.8}
          environment="city"
          adjustCamera={false}
          shadows={{ type: "contact", opacity: 0.8, blur: 1.5 }}
        >
          <Gameboy scale={1} position={[0, -1, 0]} />
        </Stage>
      </Suspense>
    </>
  );
}
